import { cn } from '@/lib/utils';

export default function SettingsTabTitle({
  title,
  className,
}: {
  title: string;
  className?: string;
}) {
  return <h5 className={cn('mb-4 font-medium', className)}>{title}</h5>;
}
